module.exports = __webpack_public_path__ + "img/faq02.76fc088a.svg";